(ns frontend.ui.component.search-input.view
  "Key concepts to understand to work with inputs:

   From https://reactjs.org/docs/forms.html#controlled-components :

   > In HTML, form elements such as <input>, <textarea>, and <select> typically
   > maintain their own state and update it based on user input. In React, mutable
   > state is typically kept in the state property of components, and only updated
   > with setState().

   > We can combine the two by making the React state be the “single source of
   > truth”. Then the React component that renders a form also controls what
   > happens in that form on subsequent user input. An input form element whose
   > value is controlled by React in this way is called a “controlled component”

   This component is such a \"controlled component\" as we set field `:value` (and
   `on-change`)."
  (:require
   [frontend.ui.component.search-input.style :as style]
   [frontend.ui.component.icon.view :refer [icon]]
   [herb.core :refer [<class]]))

(defn search-input
  [{:keys [id type value on-change]}]
  [:div
   {:class (<class style/container)}
   [:input
    {:class     (<class style/search-input)
     :id        id
     :type      type
     :value     value
     :on-change #(on-change (->> %
                                 .-target
                                 .-value))}]
   [icon
    {:class (<class style/search-icon)}
    :search]])
